import React, { Component } from 'react';

export default class Input extends Component {
    render () {
        styles.checkbox.background = (this.props.checked) ? '#50746c' : '#e1ebe9';
        let {onChange} = this.props;
        if (!onChange) {
            onChange = () => {};
        }
        return (
            <div onClick={() => onChange()} style={styles.container}>
                <div style={styles.checkboxContainer}>
                    <div style={styles.checkbox} />
                </div>
                <div style={styles.label}>
                    <p style={(this.props.correct) ? this.props.textStyle : {color: 'black'}}>{this.props.label}</p>
                </div>
            </div>
        );
    }
}

const styles = {
    container: {
        display: 'flex', flexDirection: 'row', alignItems: 'center'
    },
    checkboxContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-start'
    },
    checkbox: {
        border: '2px solid #6b9b90',
        background: '#e1ebe9',
        width: '30px',
        height: '30px',
        borderRadius: '3px'
    },
    label: {
        flex: 5,
        paddingLeft: '10px'
    }
};



// WEBPACK FOOTER //
// ./src/views/components/input.js